import { connect } from "react-redux";

import { fetchMe, updateUser } from "../../../store/user/duck";
import Cookies from "./component";

const CookieContainer = connect((/*state*/) => ({}), { updateUser, fetchMe })(Cookies);

export default CookieContainer;
